<template>
    <div>
        <config-main-title>
            Layout de Etiquetas
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Layout
                </button>
            </div>
        </div>

        <az-empty-state v-if="!dados || !dados.length" />

        <div v-else>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input"
                                :id="'ativo-' + id"
                                v-model="dado.fl_ativo"
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <az-wiki topic="Etiquetas" />

        <!-- Modal -->
        <div class="modal fade" id="edicaoLayoutModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Layout Etiqueta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    placeholder="Título..."
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="select"
                                    placeholder="Tipo..."
                                    label="Tipo"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    required
                                    :optionsList="models"
                                    :validate="validate"
                                    v-model="edicao.st_model_type" />
                            </div>
                            <div class="col col12 col-md-3">
                                <az-input
                                    type="select"
                                    placeholder="Tipo de impressão..."
                                    label="Tipo de impressão"
                                    optionsDisplay="search"
                                    required
                                    @input="onChangeTipoImpressao()"
                                    :optionsList="[{id: 'P', search: 'PDF'}, {id: 'S', search: 'Servidor de impressão'}]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="edicao.ch_tipo_impressao" />
                            </div>
                        </div>

                        <div class="form-row" v-if="edicao.ch_tipo_impressao != 'S'">
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Largura"
                                    type="number"
                                    required
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    :validate="validate"
                                    v-model="edicao.in_largura_mm">
                                    <template v-if="edicao.ch_tipo_impressao != 'S'" v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">mm</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Altura"
                                    type="number"
                                    required
                                    :validate="validate"
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    v-model="edicao.in_altura_mm">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">mm</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    placeholder="1"
                                    label="Margem"
                                    type="number"
                                    :validate="validate"
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    v-model="edicao.in_margem_mm">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">mm</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <small class="form-text text-muted text-nowrap text-truncate">&nbsp;</small>
                                <az-input
                                    type="checkbox-group"
                                    label="Paisagem"
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    :validate="validate"
                                    v-model="edicao.fl_paisagem" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="edicao.st_model_type != 'relatorios'">
                                <small class="form-text text-muted text-nowrap text-truncate">&nbsp;</small>
                                <az-input
                                    type="checkbox-group"
                                    label="Layout em HTML"
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    :validate="validate"
                                    v-model="edicao.fl_layout_html" />
                            </div>
                        </div>

                        <div v-else class="form-row">
                            <div class="col col-12 col-md-3" v-if="edicao.st_model_type != 'relatorios'">
                                <small class="form-text text-muted text-nowrap text-truncate">&nbsp;</small>
                                <az-input
                                    type="checkbox-group"
                                    label="Layout em EPL"
                                    :edicao="edicao.ch_tipo_impressao == 'S'"
                                    :validate="validate"
                                    v-model="edicao.fl_layout_html" />
                            </div>
                        </div>

                        <div class="form-row" v-if="exibir_colunas">
                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Coluna(s)"
                                    type="number"
                                    required
                                    :edicao="edicao.ch_tipo_impressao != 'S'"
                                    :validate="validate"
                                    v-model="edicao.in_colunas">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4" v-if="edicao.st_model_type == 'relatorios'">
                                <az-input
                                    placeholder="Selecionar relatório..."
                                    label="Relatório"
                                    type="select"
                                    required
                                    :optionsList="relatorios"
                                    optionsDisplay="title"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="edicao.id_relatorio"
                                />
                            </div>

                        </div>

                        <div class="form-row" v-if="edicao.ch_tipo_impressao != 'S' && !edicao.fl_layout_html && edicao.id_etiqueta_layout">
                            <div class="col col-12 col-md-6">
                                <small class="text-muted">
                                    Logo na Etiqueta
                                </small>
                                <div class="d-flex">
                                    <az-single-image-loader
                                        chave="logo"
                                        titulo="Logo"
                                        :single="true"
                                        :arquivo="edicao.logo"
                                        :parms="{ model_type: 'etiquetaLayout', model_id: edicao.id_etiqueta_layout }"
                                        service="etiqueta_layouts">
                                    </az-single-image-loader>
                                </div>
                            </div>
                        </div>

                        <az-sub-title class="mt-3" :title="edicao.fl_layout_html ? (edicao.ch_tipo_impressao != 'S' ? 'Layout em HTML' : 'Layout em EPL') : 'Layout'"></az-sub-title>

                        <!-- LAYOUT EM HTML -->

                        <template v-if="edicao.fl_layout_html">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Campo"
                                        :compact="true"
                                        type="select"
                                        :optionsList="lista_campos"
                                        optionsDisplay="search"
                                        v-model="novo_campo">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" :disabled="!novo_campo" @click="colar_campo()">
                                                    <i class="fas fa-paste"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="textarea"
                                        rows="10"
                                        required
                                        :validate="validate"
                                        v-model="edicao.st_layout_html" />
                                </div>
                            </div>
                        </template>

                        <!-- LAYOUT EM CAMPOS -->

                        <template v-if="!edicao.fl_layout_html && edicao.st_layout_json !== null">
                            <div class="form-row" v-for="(campo, icx) in edicao.st_layout_json" :key="icx">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        :optionsList="lista_campos"
                                        optionsDisplay="search"
                                        optionsData="search"
                                        :label="icx ? '' : 'Campo'"
                                        required
                                        :validate="validate"
                                        v-model="campo.nome">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_campo(icx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        :label="icx ? '' : 'Titulo'"
                                        :validate="validate"
                                        v-model="campo.titulo">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        type="number"
                                        sizing="sm"
                                        :label="icx ? '' : 'Linha'"
                                        :validate="validate"
                                        v-model="campo.linha">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        type="number"
                                        sizing="sm"
                                        :label="icx ? '' : 'Ordem'"
                                        :validate="validate"
                                        v-model="campo.ordem">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        :label="icx ? '' : 'Tamanho'"
                                        placeholder="9..."
                                        :validate="validate"
                                        v-model="campo.tamanho">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">{{campo.nome == 'logo' ? 'width (px)' : 'pt'}}</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <button type="button" class="btn btn-primary mt-3" @click="incluir_campo()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button :id="edicao.id_etiqueta_layout" model="etiquetaLayout" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_etiqueta_layout ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzWiki from '../../util/AzWiki.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() {
        return {
            dados: null,
            breadcrumb: null,
            search: "",
            viewMode: "A",
            edicao: null,
            validate: false,
            models: [],
            novo_campo: "",
        };
    },

    components: {
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzSubTitle,
        AzWiki,
        AzSingleImageLoader,
        AzAuditLogButton, 
    },

    computed: {
        lista: function() {
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => this.viewMode == 'A' ? item.fl_ativo : true)
                .filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_campos: function() {
            if ( !this.edicao || !this.edicao.st_model_type )
                return [];

            if(this.edicao.st_model_type == 'relatorios' && this.edicao.id_relatorio) {
                let relatorio = this.relatorios.find(item => item.id == this.edicao.id_relatorio);

                if(relatorio && relatorio.config && relatorio.config.columns) {
                    return relatorio.config.columns.map(item => {
                        return {
                            id: item.name,
                            search: item.name,
                        }
                    });
                }

                return [];
            }

            let model = this.models.find(item => item.id == this.edicao.st_model_type);

            return ( model && model.campos ) ? model.campos : [];
        },

        exibir_colunas: function() {
             if ( !this.edicao || !this.edicao.st_model_type )
                return false;

            return (
                (this.edicao.ch_tipo_impressao != 'S' && this.edicao.st_model_type == 'App\\azure\\estoqueLote') ||
                (this.edicao.ch_tipo_impressao == 'P' && this.edicao.st_model_type == 'relatorios')
            );
        }

    },

    methods: {
        toggle (item) {

            this.$util.toggle(this, {
                service: 'etiqueta_layouts',
                dados: item,
            });

        },

        editar (item) {
            this.validate = false;
            this.novo_campo = "";
            this.edicao = _.cloneDeep(item);

            $('#edicaoLayoutModal').modal('show');
        },

        load() {
            this.$util.load(this, {
                service: 'etiqueta_layouts',
                parms: {
                    cadastro: true,
                },
            });
        },

        incluir_campo() {
            this.edicao.st_layout_json.push({
                nome: "",
                titulo: "",
                linha: 1,
                ordem: 1,
                tamanho: 9,
            });
        },

        remover_campo(index) {
            this.edicao.st_layout_json.splice(index, 1);
        },

        colar_campo() {
            if ( !this.novo_campo )
                return;

            this.edicao.st_layout_html = this.edicao.st_layout_html + '{' + this.novo_campo.search + '}';
        },

        incluir() {
            this.validate = false;
            this.novo_campo = "";

            this.edicao = {
                id_etiqueta_layout: null,
                in_largura_mm: 50,
                in_altura_mm: 30,
                in_margem_mm: "",
                st_titulo: "",
                st_model_type: 'App\\azure\\marcacao',
                fl_layout_html: false,
                st_layout_json: [],
                st_layout_html: "",
                fl_ativo: true,
                st_observacao: "",
            };

            $('#edicaoLayoutModal').modal('show');
        },

        atualizar() {
            this.$util.atualizar(this, {
                service: 'etiqueta_layouts',
                dados: this.edicao,
                modal: 'edicaoLayoutModal',
                reload: true,
            });
        },

        onChangeTipoImpressao() {
            if(this.edicao &&
                this.edicao.ch_tipo_impressao &&
                this.edicao.ch_tipo_impressao == 'S' &&
                this.edicao.fl_layout_html) {

                this.edicao.fl_layout_html = false;

            }
        },

        loadRelatorios() {
            this.$util.loadItem(this, {
                service: 'campanhas',
                func: 'relatorios',
            })
            .then(res => {
                this.relatorios = res;
            });
        },
    },

    mounted() {

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Layout de Etiquetas" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, {
            service: 'etiquetas',
            func: 'models',
        })
        .then(res => {
            this.models = res;
            this.loadRelatorios();
        })

        this.load();

    }
}
</script>
